import { render, staticRenderFns } from "./branch-info.vue?vue&type=template&id=2ad25874&scoped=true&"
import script from "./branch-info.vue?vue&type=script&lang=js&"
export * from "./branch-info.vue?vue&type=script&lang=js&"
import style0 from "./branch-info.vue?vue&type=style&index=0&id=2ad25874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad25874",
  null
  
)

export default component.exports